<template>
  <div class="mall-profile-empty">
    <div class="mall-profile-empty__img-area">
      <img
        class="mall-profile-empty__glow"
        src="@/assets/mall/img_mall_glow.svg"
        alt=""
      />
      <img
        class="mall-profile-empty__icon"
        src="@/assets/mall/img_mall_3d.png"
        alt="컨시어지몰"
      />
    </div>
    <div class="mall-profile-empty__text">
      <span class="typo-lg-semi">컨시어지몰을 이용하시려면<br />환자등록이 필요해요</span>
      <span class="typo-body-s-medium mall-profile-empty__desc">한 번만 등록하면<br />컨시어지몰을 바로 이용할 수 있어요.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallProfileEmpty',
}
</script>

<style scoped>
/* 하단 버튼 영역(90px) + 여백(16px)을 제외한 높이 기준으로 가운데 정렬 */
.mall-profile-empty {
  display: flex;
  min-height: 100vh;
  padding: 0 32px 106px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
}

.mall-profile-empty__img-area {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
  overflow: hidden;
}

.mall-profile-empty__glow {
  position: absolute;
  top: -4px;
  left: -7px;
}

.mall-profile-empty__icon {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 100px;
  height: 100px;
}

.mall-profile-empty__text {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
  text-align: center;
}

.mall-profile-empty__desc {
  color: #4E5968;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallProfileEmpty.vue